import type { Locale } from '@seek/melways-sites';
import { useTranslations } from '@vocab/react';
import { useEffect } from 'react';

import { analyticsEvents } from 'src/constants/analytics';
import { TRACKING_DASHBOARD_JOB_LIST } from 'src/constants/tracking';
import { trackPageInteraction } from 'src/modules/AnalyticsTracker';

import TrackingButtonLink from '../TrackingButtonLink/TrackingButtonLink';

import translations from './.vocab';

interface Props {
  showDialog: React.Dispatch<React.SetStateAction<boolean>>;
  locale: Locale;
}

// This button is a component in RecentJobs because we want to track
// when this button is viewed. The event should be fired once this component
// is mounted.
const FindRecruiterDialogButton = ({ showDialog, locale }: Props) => {
  const { t } = useTranslations(translations);

  let dialogElementText;
  switch (locale) {
    case 'en-MY':
    case 'en-HK':
      dialogElementText = t('try-smarthire');
      break;
    default:
      dialogElementText = t('find-a-recruiter');
      break;
  }

  useEffect(() => {
    trackPageInteraction(
      analyticsEvents.TRACK_FIND_RECRUITER_VIEWED,
      undefined,
      {
        elementDesign: 'button',
        elementText: dialogElementText,
      },
    );
  }, [dialogElementText]);

  return (
    <TrackingButtonLink
      variant="ghost"
      tone="brandAccent"
      onClick={() => showDialog(true)}
      href="#"
      trackingEventName={analyticsEvents.TRACK_FIND_RECRUITER_PRESSED}
      trackingActionOrigin={TRACKING_DASHBOARD_JOB_LIST}
      trackingData={{
        elementAction: 'internal redirect',
        elementDesign: 'button',
        elementText: dialogElementText,
        entryPoint: TRACKING_DASHBOARD_JOB_LIST,
      }}
    >
      {dialogElementText}
    </TrackingButtonLink>
  );
};

export default FindRecruiterDialogButton;
